import { render, staticRenderFns } from "./post.vue?vue&type=template&id=0fcae2b4&"
import script from "./post.vue?vue&type=script&lang=ts&"
export * from "./post.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fcae2b4')) {
      api.createRecord('0fcae2b4', component.options)
    } else {
      api.reload('0fcae2b4', component.options)
    }
    module.hot.accept("./post.vue?vue&type=template&id=0fcae2b4&", function () {
      api.rerender('0fcae2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/guide/post.vue"
export default component.exports